module.exports = __webpack_public_path__ + "img/doctor.3a77ff66.svg";